export default __webpack_public_path__ + "static/media/massup_xl1.a15a55db.png";